import { Fragment } from "react";
import style from "./input_select.module.css";
import React, { useState, useEffect, useImperativeHandle } from "react";
import { className as cx } from "@/helpers/utility/class_name";

const InputSelect = React.forwardRef(
  (
    {
      name = "",
      options = [], //If no values array supply, then use options as a value
      values = [],
      placeholder = "",
      onChange = () => {},
      onBlur = () => {},
      errorMsg = "",
      setValue: parentSetValue = (value) => {},
      initValue = "",
      title = "",
      layout = "",
      theme = "blue",
      hasUnChangeState = false,
      withRequiredMark = false,
      ...props
    },
    ref
  ) => {
    const [isError, setIsError] = useState();
    const [value, setValue] = useState(initValue);
    const [selectBoxClasses, setSelectBoxClasses] = useState(style.select_box);
    const [selectWrapperClasses, setSelectWrapperClasses] = useState(style.select_wrapper);
    const [unChangeState, setUnChangeState] = useState(hasUnChangeState);

    useEffect(() => {
      // select_box classes
      const selectBoxClasses = () => {
        let _classList = [style.select_box];
        if (title === '') _classList.push('no_select_title');
        if (layout === 'rounded') _classList.push('rounded_selected');

        return _classList.join(' ');
      };

      const selectWrapperClasses = () => {
        const _selectWrapperClasses = [style.select_wrapper];

        switch (theme) {
          case "blue":
            _selectWrapperClasses.push(style.theme_blue);
            break;
          case "black":
            _selectWrapperClasses.push(style.theme_black);
            break;
        }

        return _selectWrapperClasses.join(' ');
      };

      setSelectBoxClasses(selectBoxClasses());
      setSelectWrapperClasses(selectWrapperClasses());
    }, []);

    useEffect(() => {
      setValue(initValue);
      parentSetValue(initValue);
    }, [initValue]);

    useEffect(() => {
      errorMsg = errorMsg === null ? "" : errorMsg;
      const err = errorMsg != "" ? true : false;
      setIsError(err);
    }, [errorMsg]);

    const setClear = () => {
      setValue("");
      parentSetValue("");
    };

    const setInputValue = (value) => {
      setValue(value);
      parentSetValue(value);
    };

    const onChangeInputHandler = (e) => {
      const selectedValue = e.target.value;
      onChange(e);
      setValue(selectedValue);
      parentSetValue(selectedValue);
      setUnChangeState(false);
    };

    //External method provide for ref
    useImperativeHandle(ref, () => {
      return {
        setClear: setClear,
        setInputValue: setInputValue,
        value: value,
      };
    });

    return (
      <Fragment>
        <div className={cx(selectWrapperClasses, isError ? style.error : '')}>
          {title != "" && (
            <p className={style.title}>
              {title}
              {(withRequiredMark && isError) && (
                <span className={style.required_flag}>*</span>
              )}
            </p>
          )}
          <div className={cx(selectBoxClasses, (unChangeState && !value) ? style.unselected : '')}>
            <select
              onChange={onChangeInputHandler}
              onBlur={onBlur}
              name={name}
              value={value}
            >
              {placeholder != "" && (
                <option
                  key="default"
                  value=""
                  disabled={options.length > 0 ? true : false}
                >
                  {placeholder}
                </option>
              )}
              {options.map((option, index) => (
                <option key={index} value={values[index]}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          {isError && <p className={style.error_msg}>{errorMsg}</p>}
        </div>
      </Fragment>
    );
  }
);

export default InputSelect;
